<style>
    .center-spinner {
        position: absolute;
        top: 50%;
        left: 50%;
        -moz-transform: translateX(-50%) translateY(-50%);
        -webkit-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
    }

    .overlay-spinner {
        height: 100vh;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.286);
        z-index: 10;
        top: 0;
        left: 0;
        position: fixed;
    }
</style>

<div id="container-full">
    <router-outlet>
        <div class="overlay-spinner" *ngIf="activePageSpinner()">
            <div class="center-spinner">
                <mat-spinner color="warn"></mat-spinner>
            </div>
        </div>
        <app-spinner></app-spinner>
    </router-outlet>
</div>

<div id="footer-gradient">
    <div fxLayout="row" fxLayoutWrap="wrap" fxLayoutAlign="center center" style="padding: 20px 0px 20px 0px;">
        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" fxLayoutAlign="center center">
            <img style="max-height:50px;" class="img-fluid" src="../../../assets/images/footer_text.png" alt="footer">
        </div>
    </div>
</div>